import { OrgSites, Site } from "~/entities/siteEntities";
import Client from "../baseClient";
import { getSubdomainFromRequest } from "~/helpers/requestHelpers";
import { DomainSetting } from "~/entities/domainSettingEntities";
import { OrgSettings } from "~/entities/baseEntities";
import { sanitizeGtmId } from "~/helpers/sanitizeHelpers";

export interface GetSiteResponse {
  orgId: string;
  orgName: string;
  domainSettings: DomainSetting | null;
  stripePublicKey: string;
  site: Site;
}

export interface GetSiteTimeSlotsResponse {
  times: (string | null)[];
  asapWait: number | null;
}

export interface GetAsapWaitResponse {
  asapWait: number | null;
}

export interface DomainInfo {
  id: string;
  orgName: string;
  domainSettings: DomainSetting;
  settings: OrgSettings;
  useComoAuth: boolean;
  multiSite: boolean;
}

export const SiteApi = {
  getDomainInfo: async (request: Request) => {
    const result = await Client.get<DomainInfo>(
      `org/${getSubdomainFromRequest(request)}`
    );

    return {
      ...result,
      domainSettings: {
        ...result.domainSettings,
        targetGoogleTagManagerId: sanitizeGtmId(
          result.domainSettings?.targetGoogleTagManagerId
        ),
      },
    };
  },
  getOrgSites: async (request: Request) =>
    await Client.get<OrgSites>(`org/${getSubdomainFromRequest(request)}/sites`),
  getSite: async (request: Request, siteId: string) =>
    await Client.get<GetSiteResponse>(
      `org/${getSubdomainFromRequest(request)}/sites/${siteId}`
    ),
  getSiteTimeSlots: async (
    orgId: string,
    siteId: string,
    orderTypeCode: string
  ) =>
    await Client.get<GetSiteTimeSlotsResponse>(
      `${orgId}/${siteId}/timeSlots/${orderTypeCode}`
    ),
  getAsapWait: async (orgId: string, siteId: string, orderTypeCode: string) =>
    await Client.get<GetAsapWaitResponse>(
      `${orgId}/${siteId}/asapWait/${orderTypeCode}`
    ),
  getAsapWaitForOrder: async (
    orgId: string,
    siteId: string,
    orderTypeCode: string,
    orderId: string
  ) => {
    try {
      return await Client.get<GetAsapWaitResponse>(
        `${orgId}/${siteId}/asapWaitForOrder/${orderTypeCode}/${orderId}`
      );
    } catch (e: any) {
      if (e.status === 404) {
        return null;
      }
      throw e;
    }
  },
};
